import { createTheme } from '@mui/material/styles';

// Phlox-inspired look: bright white surfaces on a soft grey canvas, bold Poppins
// headings, a violet-to-blue accent gradient and pill-shaped buttons.
export const BRAND = {
  gradient: 'linear-gradient(135deg, #7b3ff2 0%, #3d7bff 100%)',
  gradientHover: 'linear-gradient(135deg, #6a2ee6 0%, #2f6bf0 100%)',
  heroGradient: 'linear-gradient(140deg, #14112b 0%, #2a1f66 55%, #3d7bff 130%)',
  violet: '#7b3ff2',
  blue: '#3d7bff',
  ink: '#1b1d2b',
  muted: '#7a7f94',
  canvas: '#f4f5f8',
  line: '#e8e8ee',
  softShadow: '0 1px 2px rgba(27,29,43,0.04), 0 8px 24px rgba(27,29,43,0.06)',
  glow: '0 8px 24px rgba(91,76,255,0.32)',
};

const theme = createTheme({
  palette: {
    mode: 'light',
    primary:    { main: '#5b4cff', light: '#8f7dff', dark: '#3f2fd9', contrastText: '#fff' },
    secondary:  { main: '#3d7bff', contrastText: '#fff' },
    success:    { main: '#1fbf8f' },
    warning:    { main: '#ffad33' },
    error:      { main: '#ff5a6e' },
    text:       { primary: BRAND.ink, secondary: BRAND.muted },
    divider:    BRAND.line,
    background: { default: BRAND.canvas, paper: '#ffffff' },
  },
  typography: {
    fontFamily: '"Poppins", "Inter", "Roboto", Arial, sans-serif',
    h3: { fontWeight: 700, letterSpacing: '-0.02em' },
    h4: { fontWeight: 700, letterSpacing: '-0.02em' },
    h5: { fontWeight: 700, letterSpacing: '-0.01em' },
    h6: { fontWeight: 600 },
    button: { fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { textTransform: 'none', borderRadius: 999, paddingInline: 20 },
        containedPrimary: {
          background: BRAND.gradient,
          '&:hover': { background: BRAND.gradientHover, boxShadow: BRAND.glow },
        },
        outlined: { borderColor: BRAND.line },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
        elevation1: { boxShadow: BRAND.softShadow },
      },
    },
    MuiCard: {
      styleOverrides: { root: { borderRadius: 16, boxShadow: BRAND.softShadow } },
    },
    MuiDialog: {
      styleOverrides: { paper: { borderRadius: 18 } },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          backgroundColor: '#fff',
          '& .MuiOutlinedInput-notchedOutline': { borderColor: BRAND.line },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            backgroundColor: '#fafafc',
            color: BRAND.muted,
            fontWeight: 600,
            fontSize: 12,
            textTransform: 'uppercase',
            letterSpacing: 0.6,
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: { root: { borderColor: BRAND.line } },
    },
    MuiChip: {
      styleOverrides: { root: { fontWeight: 600, borderRadius: 999 } },
    },
  },
});

export default theme;
